// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LastSection_testimonialSection__HDlVJ {
  align-items: center;
  padding-left: 50px;
  background-color: #f1f3f6;
  --bs-gutter-x: 0rem;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.LastSection_row__Dwmb3 {
  --bs-gutter-x: 0rem;
}

.LastSection_leftContent__MmZqc {
  flex: 1 1;
  /* max-width: 50%; */
  padding: 20px;
}
.LastSection_headerLast__Nmuhc {
  font-family: Poppins;
  font-weight: 600;
  font-size: 34px;
}

.LastSection_stars__e3Hbo {
  font-size: 1.5rem;
  color: #f5a623;
  margin-bottom: 15px;
}

.LastSection_height__VsV0u {
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.5;
  margin-bottom: 20px;
  color: #2d2d2d;
}

.LastSection_highlight__8yWx4 {
  color: #007bff;
}

.LastSection_customerInfo__oSMdw {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.LastSection_avatar__tF-Ug {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 10px;
}

.LastSection_name__pLC2L {
  font-weight: 600;
  color: #333;
  margin-bottom: 0px;
  margin-top: 12px;
  font-family: Poppins;
}

.LastSection_role__3f3yo {
  font-family: Poppins;
  font-size: 0.9rem;
  color: #777;
}

.LastSection_navigation__ebBWj {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.LastSection_navButton__sKSyx {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #eaeaea;
  border: none;
  font-size: 1.2rem;
  color: #555;
  cursor: pointer;
  transition: background-color 0.3s;
}

.LastSection_navButton__sKSyx:hover {
  background-color: #d6d6d6;
}

.LastSection_rightContent__axzNK {
  flex: 1 1;
  text-align: center;
}

.LastSection_image__jpY0z {
  /* width: 80%; */
  max-width: 420px;
  margin-top: 1rem;
  border-radius: 10px;
}
@media (min-width: 300px) and (max-width: 400px) {
  .LastSection_testimonialSection__HDlVJ {
    width: 387px;
    padding-left: 25px;
    /* margin-left: 1rem; */
  }
  .LastSection_stars__e3Hbo {
    display: flex;
    justify-content: center;
  }
  .LastSection_customerInfo__oSMdw {
    justify-content: center;
  }
  .LastSection_rightContent__axzNK {
    align-items: start;
    flex: 1 1;
  }
  .LastSection_headerLast__Nmuhc {
    display: flex;
    justify-content: center;
  }
  .LastSection_image__jpY0z {
    /* width: 80%; */
    max-width: 362px;
    margin-top: 1rem;
    border-radius: 10px;
  }
}
@media (min-width: 400px) and (max-width: 600px) {
  .LastSection_testimonialSection__HDlVJ {
    width: 435px;
    padding-left: 25px;
    /* margin-left: 1rem; */
  }
  .LastSection_stars__e3Hbo {
    display: flex;
    justify-content: center;
  }
  .LastSection_customerInfo__oSMdw {
    justify-content: center;
  }
  .LastSection_rightContent__axzNK {
    align-items: start;
    flex: 1 1;
  }
  .LastSection_headerLast__Nmuhc {
    display: flex;
    justify-content: center;
  }
  .LastSection_image__jpY0z {
    /* width: 80%; */
    max-width: 362px;
    margin-top: 1rem;
    border-radius: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/LastSection.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;AAC3C;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,SAAO;EACT;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,SAAO;EACT;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;AACF","sourcesContent":[".testimonialSection {\n  align-items: center;\n  padding-left: 50px;\n  background-color: #f1f3f6;\n  --bs-gutter-x: 0rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n.row {\n  --bs-gutter-x: 0rem;\n}\n\n.leftContent {\n  flex: 1;\n  /* max-width: 50%; */\n  padding: 20px;\n}\n.headerLast {\n  font-family: Poppins;\n  font-weight: 600;\n  font-size: 34px;\n}\n\n.stars {\n  font-size: 1.5rem;\n  color: #f5a623;\n  margin-bottom: 15px;\n}\n\n.height {\n  font-size: 2rem;\n  font-weight: 600;\n  line-height: 1.5;\n  margin-bottom: 20px;\n  color: #2d2d2d;\n}\n\n.highlight {\n  color: #007bff;\n}\n\n.customerInfo {\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.avatar {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n\n.name {\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 0px;\n  margin-top: 12px;\n  font-family: Poppins;\n}\n\n.role {\n  font-family: Poppins;\n  font-size: 0.9rem;\n  color: #777;\n}\n\n.navigation {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.navButton {\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  background-color: #eaeaea;\n  border: none;\n  font-size: 1.2rem;\n  color: #555;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.navButton:hover {\n  background-color: #d6d6d6;\n}\n\n.rightContent {\n  flex: 1;\n  text-align: center;\n}\n\n.image {\n  /* width: 80%; */\n  max-width: 420px;\n  margin-top: 1rem;\n  border-radius: 10px;\n}\n@media (min-width: 300px) and (max-width: 400px) {\n  .testimonialSection {\n    width: 387px;\n    padding-left: 25px;\n    /* margin-left: 1rem; */\n  }\n  .stars {\n    display: flex;\n    justify-content: center;\n  }\n  .customerInfo {\n    justify-content: center;\n  }\n  .rightContent {\n    align-items: start;\n    flex: 1;\n  }\n  .headerLast {\n    display: flex;\n    justify-content: center;\n  }\n  .image {\n    /* width: 80%; */\n    max-width: 362px;\n    margin-top: 1rem;\n    border-radius: 10px;\n  }\n}\n@media (min-width: 400px) and (max-width: 600px) {\n  .testimonialSection {\n    width: 435px;\n    padding-left: 25px;\n    /* margin-left: 1rem; */\n  }\n  .stars {\n    display: flex;\n    justify-content: center;\n  }\n  .customerInfo {\n    justify-content: center;\n  }\n  .rightContent {\n    align-items: start;\n    flex: 1;\n  }\n  .headerLast {\n    display: flex;\n    justify-content: center;\n  }\n  .image {\n    /* width: 80%; */\n    max-width: 362px;\n    margin-top: 1rem;\n    border-radius: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"testimonialSection": `LastSection_testimonialSection__HDlVJ`,
	"row": `LastSection_row__Dwmb3`,
	"leftContent": `LastSection_leftContent__MmZqc`,
	"headerLast": `LastSection_headerLast__Nmuhc`,
	"stars": `LastSection_stars__e3Hbo`,
	"height": `LastSection_height__VsV0u`,
	"highlight": `LastSection_highlight__8yWx4`,
	"customerInfo": `LastSection_customerInfo__oSMdw`,
	"avatar": `LastSection_avatar__tF-Ug`,
	"name": `LastSection_name__pLC2L`,
	"role": `LastSection_role__3f3yo`,
	"navigation": `LastSection_navigation__ebBWj`,
	"navButton": `LastSection_navButton__sKSyx`,
	"rightContent": `LastSection_rightContent__axzNK`,
	"image": `LastSection_image__jpY0z`
};
export default ___CSS_LOADER_EXPORT___;
